export default {"src":"https://fishbrain.com/_next/static/media/dC.149e9956.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};